import { Directive, Input, OnInit } from "@angular/core";
import { BaseFormFieldComponent } from "../base-form-field.component";

@Directive()
export abstract class BaseSelectFormFieldComponent<T> extends BaseFormFieldComponent<T> implements OnInit {
  @Input() possibleValues: string[] = [];
  @Input() possibleValuesLabels: string[] | undefined;
  @Input() placeholder: string | undefined;

  protected constructor(public readonly multiple: boolean) {
    super();
  }

  public ngOnInit(): void {
    if (this.possibleValuesLabels && this.possibleValuesLabels.length !== this.possibleValues.length) {
      throw new Error("Possible values and possible values labels must have the same length");
    }
    super.ngOnInit();
  }

  public async onInputChange(event: unknown): Promise<void> {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;
    if (this.fieldValue === inputValue) {
      return;
    }

    await this.onInputChangeInternal(inputValue);
  }
}
